import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { auth } from 'apis';
import { HANDLE_ROLE_SELECTION, SET_CREDS, SET_ROLES } from 'store/actions';
import { useMe } from 'hooks/useMe';
import { useTranslation } from 'react-i18next';
import './index.css';

const getRoleValue = (item: any) => item?.value || item?.Value;

const PublicSiteNavigator = (props: any) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { whoami } = useMe();
    const { isLoggedIn, urpfId } = useSelector((state: any) => state.auth);

    const functionsQuery = useQuery(['user-functions', urpfId], auth.getFunctions, {
        enabled: Boolean(isLoggedIn && urpfId),
        retry: 1
    });

    const availableFunctions = functionsQuery.data?.data?.urpfIds || [];
    const currentRole = availableFunctions.find((role: any) => role?.selected || role?.Selected || getRoleValue(role) === urpfId);
    const currentOrg = currentRole?.orgAbbr || currentRole?.OrgAbbr || currentRole?.orgName || currentRole?.OrgName;
    const currentRoleName = currentRole?.roleName || currentRole?.RoleName;

    const goToPublicSite = () => {
        window.open('/public', '_blank', 'noopener,noreferrer');
    };

    const openSwitchFunction = () => {
        dispatch({ type: SET_CREDS, creds: null });
        dispatch({ type: SET_ROLES, roles: availableFunctions });
        dispatch({ type: HANDLE_ROLE_SELECTION, open: true });
    };

    return (
        <div className="header-action-buttons">
            {props.projectPublicEnabled && (
                <Button className="public-site-button" onClick={goToPublicSite}>
                    {t('PublicSite', 'Public Site')}
                </Button>
            )}
            {availableFunctions.length > 1 && (
                <Box className="switch-role-section">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2" color="textSecondary">
                            {currentOrg || whoami?.personFunction?.[0]?.orgAbbr || t('CurrentRole', 'Current Role:')}
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" className="switch-role-current-role">
                            {currentRoleName ? t(currentRoleName, currentRoleName) : ''}
                        </Typography>
                        <Button variant="contained" size="small" className="switch-role-button" onClick={openSwitchFunction}>
                            {t('ChangeRole', 'Αλλαγή Ρολού')}
                        </Button>
                    </Box>
                </Box>
            )}
        </div>
    );
};

export default PublicSiteNavigator;
